import { useState } from "react";
import style from "./User.module.css";

function User() {
  const [fullName, setFullName] = useState("");
  const [userType, setUserType] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [avatar, setAvatar] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");

  function fullNameHandler(e) {
    setFullName(e.target.value);
  }

  function userTypeHandler(e) {
    setUserType(e.target.value);
  }

  function userNameHandler(e) {
    setUserName(e.target.value);
  }

  function EmailHandler(e) {
    setEmail(e.target.value);
  }

  function AvatarHandler(e) {
    setAvatar(e.target.files[0]);
  }

  function PasswordHandler(e) {
    setPassword(e.target.value);
  }

  function PhoneHandler(e) {
    setPhone(e.target.value);
  }

  async function FormSubmitHandler(e) {
    e.preventDefault();
    const data = new FormData();

    data.append("fullName", fullName);
    data.append("email", email);
    data.append("userType", userType);
    data.append("userName", userName);
    data.append("phone", phone);
    data.append("password", password);
    data.append("avatar", avatar);

    try {
      const result = await fetch(
        `https://artmadein-dashboard-backend.onrender.com/api/v1/user/userregister`,
        {
          method: "POST",
          body: data,
        }
      );
      console.log(result);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <div className={style.container}>
        <div className={style.box}>
          <form onSubmit={FormSubmitHandler}>
            <input
              className={style.input}
              type="text"
              placeholder="First Name"
              name="fullName"
              onChange={fullNameHandler}
              value={fullName}
            ></input>
            <input
              className={style.input}
              type="text"
              placeholder="Email"
              name="email"
              onChange={EmailHandler}
              value={email}
            ></input>
            <input
              className={style.input}
              type="text"
              placeholder="User Type"
              name="userType"
              onChange={userTypeHandler}
              value={userType}
            ></input>
            <input
              className={style.input}
              type="text"
              placeholder="User Name"
              name="userName"
              onChange={userNameHandler}
              value={userName}
            ></input>
            <input
              className={style.input}
              type="text"
              placeholder="Phone Number"
              onChange={PhoneHandler}
              name="phone"
              value={phone}
            ></input>
            <input
              className={style.input}
              type="text"
              placeholder="Password"
              onChange={PasswordHandler}
              name="password"
              value={password}
            ></input>
            <input
              className={style.inputfile}
              type="file"
              name="avatar"
              onChange={AvatarHandler}
            ></input>
            <button className={style.btn}>Create</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default User;
